import React from 'react';
import { OverlayProvider as Component } from '@vfuk/core-overlay-controller';
const OverlayProvider = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default OverlayProvider;
